var map = {
	"./icon-warning-avalanches-orange.svg": "160f",
	"./icon-warning-avalanches-red.svg": "ec68",
	"./icon-warning-avalanches-yellow.svg": "3aff",
	"./icon-warning-drivingconditions-2.svg": "2898",
	"./icon-warning-drivingconditions-3.svg": "3e54",
	"./icon-warning-drivingconditions-4.svg": "45ff",
	"./icon-warning-drivingconditions-orange.svg": "c59f",
	"./icon-warning-drivingconditions-red.svg": "d3f9",
	"./icon-warning-drivingconditions-yellow.svg": "9175",
	"./icon-warning-extreme.svg": "1ab4",
	"./icon-warning-flom-2.svg": "5260",
	"./icon-warning-flom-3.svg": "c680",
	"./icon-warning-flom-4.svg": "0e65",
	"./icon-warning-flood-2.svg": "f4aa",
	"./icon-warning-flood-3.svg": "f6f5",
	"./icon-warning-flood-4.svg": "bdb7",
	"./icon-warning-flood-orange.svg": "243e",
	"./icon-warning-flood-red.svg": "1f8b",
	"./icon-warning-flood-yellow.svg": "132c",
	"./icon-warning-forestfire-orange.svg": "4ee9",
	"./icon-warning-forestfire-red.svg": "954c",
	"./icon-warning-forestfire-yellow.svg": "e50b",
	"./icon-warning-generic-2.svg": "d59f",
	"./icon-warning-generic-3.svg": "38bf",
	"./icon-warning-generic-4.svg": "217f",
	"./icon-warning-generic-orange.svg": "0b3f",
	"./icon-warning-generic-red.svg": "1bf3",
	"./icon-warning-generic-yellow.svg": "f9a0",
	"./icon-warning-ice-orange.svg": "07f1",
	"./icon-warning-ice-red.svg": "c597",
	"./icon-warning-ice-yellow.svg": "8122",
	"./icon-warning-icing-2.svg": "a783",
	"./icon-warning-icing-3.svg": "512c",
	"./icon-warning-icing-4.svg": "1ff3",
	"./icon-warning-icing-orange.svg": "96bf",
	"./icon-warning-icing-red.svg": "b0f4",
	"./icon-warning-icing-yellow.svg": "4454",
	"./icon-warning-jordskred-2.svg": "ed90",
	"./icon-warning-jordskred-3.svg": "72a0",
	"./icon-warning-jordskred-4.svg": "8d34",
	"./icon-warning-landslide-orange.svg": "f927",
	"./icon-warning-landslide-red.svg": "bf84",
	"./icon-warning-landslide-yellow.svg": "30b2",
	"./icon-warning-polarlow-orange.svg": "fa91",
	"./icon-warning-polarlow-red.svg": "7e22",
	"./icon-warning-polarlow-yellow.svg": "85d9",
	"./icon-warning-polartlavtrykk-2.svg": "dcee",
	"./icon-warning-polartlavtrykk-3.svg": "e32d",
	"./icon-warning-polartlavtrykk-4.svg": "60ae",
	"./icon-warning-rain-orange.svg": "e132",
	"./icon-warning-rain-red.svg": "7dc1",
	"./icon-warning-rain-yellow.svg": "f862",
	"./icon-warning-regn-2.svg": "741e",
	"./icon-warning-regn-3.svg": "df97",
	"./icon-warning-regn-4.svg": "859d",
	"./icon-warning-skogbrannfare-2.svg": "bb80",
	"./icon-warning-skogbrannfare-3.svg": "ba13",
	"./icon-warning-skogbrannfare-4.svg": "535e",
	"./icon-warning-snow-orange.svg": "6d03",
	"./icon-warning-snow-red.svg": "56c0",
	"./icon-warning-snow-yellow.svg": "2a65",
	"./icon-warning-snø-2.svg": "46b3",
	"./icon-warning-snø-3.svg": "4420",
	"./icon-warning-snø-4.svg": "28dd",
	"./icon-warning-snøskred-2.svg": "f761",
	"./icon-warning-snøskred-3.svg": "9348",
	"./icon-warning-snøskred-4.svg": "e52b",
	"./icon-warning-stormflo-2.svg": "e459",
	"./icon-warning-stormflo-3.svg": "ce1d",
	"./icon-warning-stormflo-4.svg": "d93a",
	"./icon-warning-stormsurge-orange.svg": "a85b",
	"./icon-warning-stormsurge-red.svg": "abd6",
	"./icon-warning-stormsurge-yellow.svg": "c742",
	"./icon-warning-styrtregn-2.svg": "7010",
	"./icon-warning-styrtregn-3.svg": "c6e7",
	"./icon-warning-styrtregn-4.svg": "05da",
	"./icon-warning-thunder-2.svg": "4a00",
	"./icon-warning-thunder-3.svg": "f0e7",
	"./icon-warning-thunder-4.svg": "ed52",
	"./icon-warning-thunder-orange.svg": "ba99",
	"./icon-warning-thunder-red.svg": "12bc",
	"./icon-warning-thunder-yellow.svg": "d658",
	"./icon-warning-vind-2.svg": "1808",
	"./icon-warning-vind-3.svg": "e951",
	"./icon-warning-vind-4.svg": "e363",
	"./icon-warning-wind-orange.svg": "90e0",
	"./icon-warning-wind-red.svg": "d336",
	"./icon-warning-wind-yellow.svg": "d06a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e5a3";